const wait = (timeInMilliseconds) => {
    return new Promise(res => setTimeout(res, timeInMilliseconds));
};

export default wait;